//https://github.com/vandit-bera/React-Routing
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ErrorPage from './component/ErrorPage';
import App from './App';
import Legal from "./component/Legal";
import AfClubUnite from "./component/AfClubUnite";
import Contact from "./component/Contact";
import Home from "./component/Home";
import Services from "./component/Services";
import PageWithData from "./component/PageWithData";
import WorkView_1 from "./component/WorkView_1";
import WorkCat from "./component/WorkCat";
import WorkLaunch from "./component/WorkLaunch";
import WorkNews from "./component/WorkNews";
import NewsView_1 from "./component/NewsView_1";
import { createBrowserRouter,RouterProvider } from 'react-router-dom';
import ThemeProvider from './context/ThemeProvider';

const fetchProjectsHome = async () => {
const response = await fetch('https://discover.af-pictures.com/app/v1/video-data-af-all-2');
return await response.json();
};
const fetchProjectsCat = async () => {
const response = await fetch('https://discover.af-pictures.com/app/v1/video-data-af-catalogo-1');
return await response.json();
};
const fetchProjectsLaunch = async () => {
const response = await fetch('https://discover.af-pictures.com/app/v1/video-data-af-launch-1');
return await response.json();
};
/*const fetchProjectsDoc = async () => {
const response = await fetch('https://discover.af-pictures.com/app/v1/video-data-af-doc');
return await response.json();
};*/
const fetchNews = async () => {
const response = await fetch('https://discover.af-pictures.com/api/v1/blog');
return await response.json();
};

const fetchPoliticaCookies = async () => {
const response = await fetch('https://discover.af-pictures.com//app/v1/page/1/politica-cookies');
return await response.json();
};

const fetchLegal = async () => {
const response = await fetch('https://discover.af-pictures.com//app/v1/page/1/legal');
return await response.json();
};

const fetchPrivacy = async () => {
const response = await fetch('https://discover.af-pictures.com//app/v1/page/1/politica-privacidad');
return await response.json();
};

const fetchSocial = async () => {
const response = await fetch('https://discover.af-pictures.com/app/v1/social');
return await response.json();
};


const router = createBrowserRouter([
  {
    element: <App />,
    loader: fetchSocial,
     errorElement: <ErrorPage transition={`${'fadeIn'}`}/>,
    children: [
  {
    path: "/",
    element: <Home transition={`${'fadeIn'}`} />,
    loader: fetchProjectsHome,
  },
  {
    path: "/catalogo",
    element: <WorkCat title={'CATÁLOGO'} transition={`${'fadeIn'}`} />,
    loader: fetchProjectsCat,
    children: [
      {
        path: ":id",
        element: <WorkView_1 transition={`${'fadeIn'}`} />,
        loader: fetchProjectsCat,
        errorElement: <ErrorPage transition={`${'fadeIn'}`} />,
      },
    ],
  },
  /*{
    path: "/documentales",
    element: <WorkDoc title={'documentales'} transition={`${'fadeIn'}`} />,
    loader: fetchProjectsDoc,
    children: [
      {
        path: ":id",
        element: <WorkView_1 transition={`${'fadeIn'}`} />,
        loader: fetchProjectsDoc,
        errorElement: <ErrorPage transition={`${'fadeIn'}`} />,
      },
    ],
  },*/
  {
    path: "/estrenos",
    element: <WorkLaunch title={'ESTRENOS'} transition={`${'fadeIn'}`} />,
    loader: fetchProjectsLaunch,
    children: [
      {
        path: ":id",
        element: <WorkView_1 transition={`${'fadeIn'}`} />,
        loader: fetchProjectsLaunch,
        errorElement: <ErrorPage transition={`${'fadeIn'}`} />,
      },
    ],
  },
  {
    path: "/noticias",
    element: <WorkNews title={'NOTICIAS'} transition={`${'fadeIn'}`} />,
    loader: fetchNews,
    children: [
      {
        path: ":id",
        element: <NewsView_1 transition={`${'fadeIn'}`} />,
        loader: fetchNews,
        errorElement: <ErrorPage transition={`${'fadeIn'}`} />,
      },
    ],
  },
  {
    path: "/servicios",
    element: <Services transition={`${'fadeIn'}`} />,
  },
  {
    path: "/contacto",
    element: <Contact transition={`${'fadeIn'}`} />,
  },
  {
    path: "/politica-privacidad",
    loader: fetchPrivacy,
    element: <PageWithData transition={`${'fadeIn'}`} />,
  },
  {
    path: "/privacy",
    loader: fetchPoliticaCookies,
    element: <PageWithData transition={`${'fadeIn'}`} />,
  },
  {
    path: "/legal",
    loader: fetchLegal,
    element: <PageWithData transition={`${'fadeIn'}`} />,
  },
  {
    path: "/theclub",
    element: <AfClubUnite transition={`${'fadeIn'}`} />,
  },
]
    }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <ThemeProvider>
    <RouterProvider router={router} future={{ v7_startTransition: true }}>
    </RouterProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
